import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title d-block" }
const _hoisted_4 = { class: "d-flex align-items-center mb-3" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "card-body py-4" }
const _hoisted_8 = {
  class: "table align-middle table-row-dashed fs-6 gy-5 table-hover",
  id: "table_accounts_requests"
}
const _hoisted_9 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 2,
  class: "fw-semibold text-gray-600"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "d-md-flex align-items-center" }
const _hoisted_24 = {
  key: 0,
  class: "fa-solid fa-check fa-xl",
  style: {"color":"#4ed06e"}
}
const _hoisted_25 = {
  key: 1,
  class: "fa-solid fa-xmark fa-xl",
  style: {"color":"#d92626"}
}
const _hoisted_26 = ["onClick"]

import { ref, onMounted, inject } from "vue";
import UserService from "../../services/UserService";
import { LeadIsArchivedTypes } from "@/core/types/LeadIsArchivedTypes";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import LeadCreateModal from "./LeadCreateModal.vue";
import AssignToSalesModal from "./AssignToSalesModal.vue";
import LeadDetailsModal from "./LeadDetailsModal.vue";
import AutoAssignModal from "./AutoAssignModal.vue";
import { Search } from "@element-plus/icons-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainIndex',
  setup(__props) {

const isLoading = inject<any>("isLoading");
const data = ref<any>([]);
const accountSelected = ref(0);
const leadCreateModalRef = ref<InstanceType<typeof LeadCreateModal>>();
const assignToSalesModalRef = ref<InstanceType<typeof AssignToSalesModal>>();
const leadDetailsModalRef = ref<InstanceType<typeof LeadDetailsModal>>();
const autoAssignModalRef = ref<InstanceType<typeof AutoAssignModal>>();
const selectedLeads = ref(Array<any>());
const criteria = ref<any>({
  page: 1,
  size: 20,
});

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await UserService.queryRepLeads(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    isLoading.value = false;
  }
};

const reset = async () => {
  criteria.value = {
    page: 1,
    size: 20,
  };
  await fetchData(1);
};

const openAssignSalesModal = () => {
  assignToSalesModalRef.value?.show(selectedLeads.value);
};
const openCreateLeadModal = () => {
  leadCreateModalRef.value?.show();
};

const openAutoAssignSetting = () => {
  autoAssignModalRef.value?.show();
};

const assignSalesSuccess = () => {
  selectedLeads.value = [];
  fetchData(1);
};

const openLeadDetailsModal = (_lead) => {
  leadDetailsModalRef.value?.show(_lead);
};

const selectedAccount = (id: number) => {
  accountSelected.value = id;
};
onMounted(async () => {
  await fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            modelValue: criteria.value.keyword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.keyword) = $event)),
            placeholder: "Keyword (Email / Name / PhoneNumber)",
            clearable: "",
            class: "me-5",
            style: {"width":"350px","flex-shrink":"0"}
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _unref(Search),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchData(1))),
                loading: _unref(isLoading)
              }, null, 8, ["icon", "loading"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_input, {
            modelValue: criteria.value.assignedAccountUid,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((criteria.value.assignedAccountUid) = $event)),
            placeholder: "AccountUid",
            clearable: "",
            class: "me-5",
            style: {"width":"200px","flex-shrink":"0"}
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _unref(Search),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1))),
                loading: _unref(isLoading)
              }, null, 8, ["icon", "loading"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            disabled: _unref(isLoading),
            onClick: reset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_select, {
            modelValue: criteria.value.isArchived,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((criteria.value.isArchived) = $event)),
            class: "me-5",
            placeholder: "Is Archived",
            clearable: "",
            onChange: _cache[5] || (_cache[5] = ($event: any) => (fetchData(1))),
            disabled: _unref(isLoading)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                value: 0,
                label: _ctx.$t('status.active')
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                value: 1,
                label: _ctx.$t('status.archived')
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"]),
          _createVNode(_component_el_select, {
            modelValue: criteria.value.isAssigned,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((criteria.value.isAssigned) = $event)),
            class: "me-5",
            placeholder: "Is Assigned",
            clearable: "",
            onChange: _cache[7] || (_cache[7] = ($event: any) => (fetchData(1))),
            disabled: _unref(isLoading)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                value: true,
                label: _ctx.$t('status.assigned')
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                value: false,
                label: _ctx.$t('status.unassigned')
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"]),
          _createVNode(_component_el_select, {
            modelValue: criteria.value.hasReferCode,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((criteria.value.hasReferCode) = $event)),
            class: "me-5",
            placeholder: "Has ReferCode",
            clearable: "",
            onChange: _cache[9] || (_cache[9] = ($event: any) => (fetchData(1))),
            disabled: _unref(isLoading)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                value: true,
                label: _ctx.$t('status.hasReferCode')
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                value: false,
                label: _ctx.$t('status.noReferCode')
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: openAutoAssignSetting,
          disabled: _unref(isLoading)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("fields.autoAssignSetting")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        (selectedLeads.value.length > 0)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "warning",
              onClick: openAssignSalesModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.assign")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: openCreateLeadModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.create")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("table", _hoisted_8, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_9, [
            _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.user")), 1),
            _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.email")), 1),
            _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("fields.phone")), 1),
            _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.source")), 1),
            _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.status")), 1),
            _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.hasAssigned")), 1),
            _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
            _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
            _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t("fields.action")), 1)
          ])
        ]),
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!_unref(isLoading) && data.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: _normalizeClass({
              'tr-select': item.id === accountSelected.value,
            }),
                    onClick: ($event: any) => (selectedAccount(item.id))
                  }, [
                    _createElementVNode("td", _hoisted_23, [
                      _createVNode(_component_UserAvatar, {
                        avatar: item.user?.avatar ?? '',
                        name: item.user?.displayName || item.name,
                        size: "40px",
                        class: "me-3",
                        side: "client",
                        rounded: ""
                      }, null, 8, ["avatar", "name"]),
                      _createElementVNode("span", null, _toDisplayString(item.user?.nativeName || item.user?.displayName || item.name), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.email), 1),
                    _createElementVNode("td", null, _toDisplayString(item.phoneNumber), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.leadSource.${item.sourceType}`)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.leadStatus.${item.status}`)), 1),
                    _createElementVNode("td", null, [
                      (item.hasAssignedToSales)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                        : (_openBlock(), _createElementBlock("i", _hoisted_25))
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        type: "inFields",
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        type: "inFields",
                        "date-iso-string": item.updatedOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: "cursor-pointer",
                        style: {"color":"#7c8fa2"},
                        onClick: ($event: any) => (openLeadDetailsModal(item))
                      }, _toDisplayString(_ctx.$t("action.showDetails")), 9, _hoisted_26)
                    ])
                  ], 10, _hoisted_22))
                }), 128))
              ]))
      ]),
      _createVNode(_component_TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _createVNode(LeadCreateModal, {
      ref_key: "leadCreateModalRef",
      ref: leadCreateModalRef,
      onCreateSuccess: assignSalesSuccess
    }, null, 512),
    _createVNode(LeadDetailsModal, {
      ref_key: "leadDetailsModalRef",
      ref: leadDetailsModalRef,
      onUpdate: assignSalesSuccess
    }, null, 512),
    _createVNode(AssignToSalesModal, {
      ref_key: "assignToSalesModalRef",
      ref: assignToSalesModalRef,
      onAssignSuccess: assignSalesSuccess
    }, null, 512),
    _createVNode(AutoAssignModal, {
      ref_key: "autoAssignModalRef",
      ref: autoAssignModalRef
    }, null, 512)
  ]))
}
}

})